import React from 'react';
import veterinaria from '@/assets/images/veterinaria.png';

const ClinicaPage = () => (
  <section className="clinic">
    <div className="container">
      <h2>Clínica Felina</h2>
      <div className="clinic-highlight">
        <h3>"Especializada em medicina felina. Aqui, seu gato é tratado com carinho e respeito."</h3>
      </div>

      <div className="vet-section">
        <div className="vet-photo">
          <img src={veterinaria} alt="Dra. Fulana de Tal" className="vet-photo" />
        </div>
        <div className="vet-info">
          <h4>Dra. Manuela da Silva Casa</h4>
          <p>CRMV 07412/SC</p>
          <p>Apaixonada por gatos e dedicada a oferecer o melhor cuidado para seu amiguinho.</p>
        </div>
      </div>
      
      <div className="services">
        <h4>Nossos Serviços:</h4>
        <div className="services-grid">
          <div className="service">
            <span>📅</span>
            <h5>Consultas Agendadas</h5>
            <p>Atendimento personalizado com hora marcada</p>
          </div>
          <div className="service">
            <span>💉</span>
            <h5>Vacinações</h5>
            <p>Protocolo completo de imunização felina</p>
          </div>
          <div className="service">
            <span>🛡️</span>
            <h5>Cuidados Preventivos</h5>
            <p>Prevenção é o melhor remédio</p>
          </div>
        </div>
      </div>

      <div className="warning">
        <span>⚠️</span>
        <p><strong>IMPORTANTE:</strong> Não atendemos emergências</p>
      </div>
    </div>
  </section>
);

export default ClinicaPage;